import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { InputCurrencyWidgetComponent } from './input-currency-widget.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [InputCurrencyWidgetComponent],
  exports: [InputCurrencyWidgetComponent],
})
export class InputCurrencyWidgetModule {}
